import { QUEUE_TABS, FOCUS_FILTERS, SORT_OPTIONS } from './workItemQueueFilters';

const TAB_IDS = new Set(QUEUE_TABS.map((t) => t.id));
const FOCUS_IDS = new Set(FOCUS_FILTERS.map((f) => f.id));
const SORT_IDS = new Set(SORT_OPTIONS.map((s) => s.id));
const PANEL_IDS = new Set(['details', 'conversation', 'time', 'activity']);

/**
 * @param {string} [search]
 * @returns {{
 *   tab: string|null,
 *   focus: string|null,
 *   sort: string,
 *   client: string,
 *   assignee: string,
 *   priority: string,
 *   project: string,
 *   panel: string,
 * }}
 */
export const parseTaskSearch = (search) => {
  const p = new URLSearchParams(search || '');
  const tab = p.get('tab');
  const focus = p.get('focus');
  const sort = p.get('sort');
  const panel = p.get('panel');
  return {
    tab: tab && TAB_IDS.has(tab) ? tab : null,
    focus: focus && FOCUS_IDS.has(focus) ? focus : null,
    sort: sort && SORT_IDS.has(sort) ? sort : 'due',
    client: p.get('client') || '',
    assignee: p.get('assignee') || '',
    priority: p.get('priority') || '',
    project: p.get('project') || '',
    panel: panel && PANEL_IDS.has(panel) ? panel : 'details',
  };
};

/**
 * @param {object} state
 * @returns {string} query string including leading `?`, or ''
 */
export const buildTaskSearch = (state) => {
  const p = new URLSearchParams();
  if (state.tab) p.set('tab', state.tab);
  if (state.focus) p.set('focus', state.focus);
  if (state.sort && state.sort !== 'due') p.set('sort', state.sort);
  if (state.client) p.set('client', state.client);
  if (state.assignee) p.set('assignee', state.assignee);
  if (state.priority) p.set('priority', state.priority);
  if (state.project) p.set('project', state.project);
  if (state.panel && state.panel !== 'details') p.set('panel', state.panel);
  const s = p.toString();
  return s ? `?${s}` : '';
};

/**
 * Team view is meaningful when more than one account manager exists.
 * @param {object|null|undefined} dashboard
 * @returns {boolean}
 */
export const canSeeWholeTeam = (dashboard) =>
  (dashboard?.teamFilter?.byMember || []).length > 1;
